
























import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { Controlador as Model, ControladorDeCurso } from '../curso-controlador';
import videos from './curso-recursos-videos.vue';
import { Recurso } from '@/__env/lib/Cursos/Recursos';
import { Wait } from '@/__env/ext';
import { clearLine } from 'readline';
import { Curso } from '@/__env/lib/Cursos';
@Component( {
    name: "Componente",
    props: {},
    components: {
    }
} )
export default class Componente extends Vue
{


    public get Controlador(): ControladorDeCurso { return Model; }
    public get Curso(): Curso { return Model.Curso; }

    public Abrir( link: string )
    {
        window.open( link );
    }
}
